import React from "react";

const STORAGE_KEY = "catchcompass:last-rod-count";

export function preferredRodCount(): number {
  if (typeof window === "undefined") return 3;
  const stored = Number(window.localStorage.getItem(STORAGE_KEY));
  return Number.isInteger(stored) && stored >= 1 && stored <= 20 ? stored : 3;
}

export function rememberRodCount(value: number) {
  if (typeof window === "undefined") return;
  const safe = Math.min(20, Math.max(1, Math.round(value || 1)));
  window.localStorage.setItem(STORAGE_KEY, String(safe));
}

export function RodCountPicker({
  value,
  onChange,
  disabled = false,
}: {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}) {
  const setSafe = (next: number) =>
    onChange(Math.min(20, Math.max(1, Math.round(next))));

  return (
    <div className="rounded-lg border border-border bg-background p-3">
      <p className="text-sm font-semibold text-primary">Rods today</p>
      <p className="mt-1 text-xs leading-5 text-secondary">
        Choose how many rods you are actually fishing. You can correct this later from Edit session.
      </p>
      <div className="mt-3 flex items-center gap-3">
        <button
          type="button"
          disabled={disabled || value <= 1}
          onClick={() => setSafe(value - 1)}
          className="flex size-11 items-center justify-center rounded-lg border border-border bg-raised text-xl font-semibold text-primary disabled:opacity-40"
          aria-label="Use one fewer rod"
        >
          −
        </button>
        <div className="min-w-14 text-center text-2xl font-bold text-primary" aria-live="polite">
          {value}
        </div>
        <button
          type="button"
          disabled={disabled || value >= 20}
          onClick={() => setSafe(value + 1)}
          className="flex size-11 items-center justify-center rounded-lg border border-border bg-raised text-xl font-semibold text-primary disabled:opacity-40"
          aria-label="Use one more rod"
        >
          +
        </button>
      </div>
    </div>
  );
}
